module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pshou3-2efecae745b92dc0a87d71a853b0454f.jpg";